import { CnButton, CnIcon } from '@alife/cn-ui';
import React from 'react';
import '../scss/operator-panel.scss';
const clsPrefix = `cn-editor-operator-panel`;
const OperatorPanel = (props) => {
    const { title, operations, extra } = props;
    if (!operations && !title && !extra) {
        return null;
    }
    const renderTitle = () => {
        if (typeof title === 'string') {
            return <div className={`${clsPrefix}-title`}>{title}</div>;
        }
        return title;
    };
    const renderOperations = () => {
        return (<div className={`${clsPrefix}-toolbar`}>
        {Array.isArray(operations) ? (<div>
            {operations?.map((btn) => (<CnButton key={btn.id} className={`${clsPrefix}-toolbar-btn`} onClick={btn.onClick} text>
                {btn.icon && <CnIcon type={btn.icon}/>}
                {btn.children}
              </CnButton>))}
          </div>) : ({ operations })}
      </div>);
    };
    return (<div className={`${clsPrefix}`}>
      <div className={`${clsPrefix}-main`}>
        {renderTitle()}
        {renderOperations()}
      </div>
      {extra && <div className={`${clsPrefix}-extra`}>{extra}</div>}
    </div>);
};
export default OperatorPanel;
